module.exports = __webpack_public_path__ + "static/img/sw_qw_1.10a63e81.png";